var _linearGradient, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharepoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1992.3339999999998 1949.7258906061272",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2447,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(1 0 0 -1 0 1948)",
    gradientUnits: "userSpaceOnUse",
    x1: 177.079,
    x2: 842.255,
    y1: 1551.028,
    y2: 398.972
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#058f92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#038489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026d71"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1019.333,
    cy: 556,
    fill: "#036c70",
    r: 556
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1482.667,
    cy: 1065.667,
    fill: "#1a9ba1",
    r: 509.667
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1088.833,
    cy: 1552.167,
    fill: "#37c6d0",
    r: 393.833
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1112 501.79v988.753c-.23 34.357-21.05 65.222-52.82 78.303a82.12 82.12 0 0 1-31.97 6.487H695.463c-.463-7.877-.463-15.29-.463-23.167-.154-7.734.155-15.47.927-23.167 8.48-148.106 99.721-278.782 235.837-337.77v-86.18c-302.932-48.005-509.592-332.495-461.587-635.427.333-2.098.677-4.195 1.034-6.289a391.8 391.8 0 0 1 9.73-46.333h546.27c46.753.178 84.611 38.036 84.789 84.79z",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M980.877 463.333H471.21c-51.486 302.386 151.908 589.256 454.293 640.742a555.466 555.466 0 0 0 27.573 3.986c-143.633 68.11-248.3 261.552-257.196 420.938a193.737 193.737 0 0 0-.927 23.167c0 7.877 0 15.29.463 23.167a309.212 309.212 0 0 0 6.023 46.333h279.39c34.357-.23 65.222-21.05 78.303-52.82a82.098 82.098 0 0 0 6.487-31.97V548.123c-.176-46.736-38.006-84.586-84.742-84.79z",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M980.877 463.333H471.21c-51.475 302.414 151.95 589.297 454.364 640.773a556.017 556.017 0 0 0 18.607 2.844c-139 73.021-239.543 266-248.254 422.05h284.95c46.681-.353 84.437-38.109 84.79-84.79V548.123c-.178-46.754-38.036-84.612-84.79-84.79z",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M934.543 463.333H471.21c-48.606 285.482 130.279 560.404 410.977 631.616A765.521 765.521 0 0 0 695.927 1529h238.617c46.754-.178 84.612-38.036 84.79-84.79V548.123c-.026-46.817-37.973-84.764-84.791-84.79z",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.929 463.333h849.475c46.905 0 84.929 38.024 84.929 84.929v849.475c0 46.905-38.024 84.929-84.929 84.929H84.929c-46.905 0-84.929-38.024-84.929-84.929V548.262c0-46.905 38.024-84.929 84.929-84.929z",
    fill: "url(#a)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M379.331 962.621a156.785 156.785 0 0 1-48.604-51.384 139.837 139.837 0 0 1-16.912-70.288 135.25 135.25 0 0 1 31.46-91.045 185.847 185.847 0 0 1 83.678-54.581 353.459 353.459 0 0 1 114.304-17.699 435.148 435.148 0 0 1 150.583 21.082v106.567a235.031 235.031 0 0 0-68.11-27.8 331.709 331.709 0 0 0-79.647-9.545 172.314 172.314 0 0 0-81.871 17.329 53.7 53.7 0 0 0-32.433 49.206 49.853 49.853 0 0 0 13.9 34.843 124.638 124.638 0 0 0 37.067 26.503c15.444 7.691 38.611 17.916 69.5 30.673a70.322 70.322 0 0 1 9.915 3.985 571.842 571.842 0 0 1 87.663 43.229 156.935 156.935 0 0 1 51.801 52.171 151.223 151.223 0 0 1 18.533 78.767 146.506 146.506 0 0 1-29.468 94.798 164.803 164.803 0 0 1-78.767 53.005 357.22 357.22 0 0 1-112.312 16.309 594.113 594.113 0 0 1-101.933-8.34 349.057 349.057 0 0 1-82.612-24.279v-112.358a266.237 266.237 0 0 0 83.4 39.847 326.268 326.268 0 0 0 92.018 14.734 158.463 158.463 0 0 0 83.4-17.699 55.971 55.971 0 0 0 28.449-49.994 53.284 53.284 0 0 0-15.753-38.271 158.715 158.715 0 0 0-43.414-30.256c-18.533-9.267-45.824-21.483-81.871-36.65a465.328 465.328 0 0 1-81.964-42.859z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharepoint);
export default __webpack_public_path__ + "static/media/sharepoint.7285748747ce3482464f5c1f493cb47a.svg";
export { ForwardRef as ReactComponent };